import { useState } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { ToastContainer, toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../toastify/config";
import apiMo from "../../axios/axios";
import { useLoginStore } from "../../store/zustand";

const ReimprimirVenta = () => {
    const [folio, setFolio] = useState("");
    const [spGenerarReporte, setSpGenerarReporte] = useState(false)
    const { loginStore } = useLoginStore()

    const buscarVenta = () => {
        if (!folio.trim()) {
            return;
        }

        const reimprimirTicket = async () => {
            try {

                setSpGenerarReporte(true)


                const generar = await apiMo.get(`/reimprimir-venta/${folio}`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setSpGenerarReporte(false)

                let byteCharacters = atob(generar.data);
                let byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                let byteArray = new Uint8Array(byteNumbers);

                let file = new Blob([byteArray], { type: 'application/pdf' });
                let fileURL = URL.createObjectURL(file);

                window.open(fileURL, '_blank')

                //mensaje

            } catch (error: any) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al reimprimir ticket de venta, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
                setSpGenerarReporte(false)
            }
        }

        reimprimirTicket()

    };

    return (
        <div className="container py-5">
            <div className="row d-flex justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow-lg">
                        <div className="card-body">

                            <div className="row">

                                <div className="col-md-6 mx-auto">

                                    <Box sx={{ textAlign: "center" }}>
                                        <Typography
                                            variant="h5"
                                            fontWeight="bold"
                                            gutterBottom
                                        >
                                            Reimprimir venta
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{ mb: 3 }}
                                        >
                                            Ingresa el número de folio de la
                                            venta que deseas reimprimir
                                        </Typography>

                                        <TextField
                                            fullWidth
                                            label="Número de folio"
                                            placeholder="Ej. CMO1/CCMO1"
                                            value={folio}
                                            onChange={(e) =>
                                                setFolio(e.target.value.toUpperCase())
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    buscarVenta();
                                                }
                                            }}
                                            autoFocus
                                        />

                                        <Button
                                            fullWidth
                                            variant="contained"
                                            size="large"
                                            startIcon={<SearchIcon />}
                                            onClick={buscarVenta}
                                            disabled={!folio.trim() || spGenerarReporte}
                                            sx={{ mt: 2 }}
                                        >
                                            Buscar venta
                                            {spGenerarReporte &&
                                                <div className="spinner-border text-light spinner-border-sm" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            }
                                        </Button>
                                    </Box>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer position="bottom-center"
                transition={Flip}
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </div>
    );
};

export default ReimprimirVenta;